var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreinosAovivo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aulas_ao_vivo",
    "data-name": "aulas ao vivo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_2_copiar",
    "data-name": "Ret\\xE2ngulo 2 copiar",
    className: "cls-1",
    d: "M30,16.5H370s30-.786,30,28.26v309.92c0,28.252-27.251,28.26-30,28.26H30c-1.052,0-30,2.865-30-28.15V44.761C0,16.014,28.813,16.5,30,16.5ZM15.666,99.409H385.379V367.361H15.666V99.409ZM40,56s8-.1,8,8c0,0,.108,8-8,8,0,0-8,.4-8-8C32,64,32.088,56,40,56Zm32,0s8-.1,8,8c0,0,.108,8-8,8,0,0-8,.4-8-8C64,64,64.088,56,72,56Zm32,0s8-.1,8,8c0,0,.108,8-8,8,0,0-8,.4-8-8C96,64,96.088,56,104,56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Forma_1",
    "data-name": "Forma 1",
    className: "cls-1",
    d: "M103.443,334.653s16.767-49.342,37.775-91.213c0,0,20.977-55.193,47.691-87.9,0,0,23.193-40.043,79.8-42.535,0,0,12.277-.029,12.277,13.706,0,0,.686,9.452-9.916,9.452,0,0-43.07-.029-66.578,38.281,0,0,13.435,8.321,15.11,17.959,0,0,25.97,20.332,25.97,45.843,0,0,.438,10.87-8.5,10.87l-47.219,8.979s-5.565,1.134-6.138-.472c0,0-1,.345.944,4.726L217.24,332.29s2.692,11.736-8.027,17.013c0,0-13.362,7.011-18.888-4.253l-31.636-69s-11.171,22.746-27.387,69c0,0-3.458,12.348-17.943,8.034C113.359,353.084,100.479,349.143,103.443,334.653ZM242.03,153.172a20.558,20.558,0,1,1-20.54,20.558A20.549,20.549,0,0,1,242.03,153.172ZM208.741,214.61a48.728,48.728,0,0,1,10.388,13.706l-24.554,4.726Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreinosAovivo);
export default __webpack_public_path__ + "static/media/treinos-aovivo.49783eb02c3eb5297255583781146961.svg";
export { ForwardRef as ReactComponent };